import { type FC } from 'react';

export const createCompoundComponent = <T, C extends CompoundComponentsMap>(
  Root: FC<T>,
  compound: C
) => Object.assign(Root, compound);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type CompoundComponentsMap = Record<Capitalize<string>, FC<any>>;
